<ul class="breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs ; let last = last"
      class="breadcrumb-item">
    <a *ngIf="!last" [routerLink]="breadcrumb.url">
      {{ breadcrumb.defaultLabel }} {{ breadcrumb.labelDyn }}
    </a>
    <span *ngIf="last">{{ breadcrumb.defaultLabel }} {{ breadcrumb.labelDyn }}</span>
  </li>
</ul>
